import RFB from '@/angular/libs/novnc';
const bcrypt = require('bcryptjs');
(function() {
    'use strict';

    angular.module('vrm.components')
        .controller('RemoteConsoleController', RemoteConsoleController);

    /* @ngInject */
    function RemoteConsoleController($window, $document, locale,installation, onClose, onOpened, ApiService, close, $log) {


        // Local state variables
        var $state = {
            element: null,
            connecting: false,
            rfb: null,
            connectionData: null,
            firstAttempt: true,
            disconnected: false,
            triedIdentifierOld: false,
        };

        // Return open and close callbacks
        return {
            open: open,
            close: function closeRemoteConsole() {
                // BUG: This function must be defined by name and let that name not be close,
                // otherwise the close parameter is renamed which breaks angular DI
                // See: https://github.com/babel/babel/issues/4782
                disconnect();

                if (onClose) {
                    onClose();
                }

                return close();
            }
        };

        // Initialization function
        function open() {
            // Element is passed in by MFP
            $state.element = this.content;

            // Installation name
            $state.element.find('.remote-console-controls-title, .remote-console-title').text(installation.name);

            // Prevent double-tap zoom in the popup
            $state.element.bind('touchstart', function(ev) {
                // Multiple fingers?
                if (ev.originalEvent.touches.length < 2) {
                    // Calculate time difference since the previous touch
                    var timeDiff = ev.timeStamp - ($state.element.data('lastTouch') || ev.timeStamp);
                    if(timeDiff && timeDiff < 500) {
                        // Prevent the zoom
                        ev.preventDefault();
                    }
                }

                // Save last touch timestamp
                $state.element.data('lastTouch', ev.timeStamp);
            });

            // Prevent hover states of buttons on touchscreens
            if('ontouchstart' in window) {
                $state.element.find('[data-button]').addClass('nohover');
            }

            // Buttons
            var timeoutId = 0;
            var intervalId = 0;
            $state.element.find('[data-button]').on('touchstart mousedown', function(ev) {
                ev.preventDefault();
                clearTimeout(timeoutId);
                clearInterval(intervalId);
                var key = $(this).data('button');
                sendButton(key);
                timeoutId = setTimeout(function () {
                    clearTimeout(timeoutId);
                    intervalId = setInterval(function () {
                        sendButton(key);
                    }, 50);
                }, 250);
            }).on('mousedown touchstart', function() {
                $(this).addClass('toggled');
            }).on('mouseup mouseleave mouseout touchcancel touchend', function() {
                clearTimeout(timeoutId);
                clearInterval(intervalId);
                $(this).removeClass('toggled');
            });
            var keyButtonMap = {
                27: 'left-button',  // Esc
                13: 'right-button', // Enter
                38: 'up',           // Arrow up
                37: 'left',         // Arrow left
                32: 'center',       // Space
                39: 'right',        // Arrow right
                40: 'down'          // Arrow down
            };
            $document[0].addEventListener('keydown', function(ev) {
                // Toggle to indicate key down
                var button = keyButtonMap[(ev.keyCode ? ev.keyCode : ev.which)];
                if(button) {
                    $state.element.find('[data-button="' + button + '"]').addClass('toggled');
                }
            });
            $document[0].addEventListener('keyup', function(ev) {
                // Toggle to indicate key up
                var button = keyButtonMap[(ev.keyCode ? ev.keyCode : ev.which)];
                if(button) {
                    $state.element.find('[data-button="' + button + '"]').removeClass('toggled');
                }
            });
            $state.element.find('[data-button]').removeClass('toggled');

            // Disconnect on unload
            $window.addEventListener('beforeunload', function() {
                disconnect();
            });

            // Resize display on window resize
            $window.addEventListener('resize', function() {
                resize();
            });

            // Close button in rotate screen message
            $('.remote-console-rotate-message-container .mfp-close').click(function() {
                $.magnificPopup.instance.close();
                $state.element.find('.remote-console-rotate-message-container').hide();
            });

            // Password form
            $state.element.find('#remote-console-login').click(sendPassword);
            $state.element.find('#remote-console-password').bind('keypress', function(ev) {
                if((ev.keyCode ? ev.keyCode : ev.which) == 13) {
                    sendPassword();
                }
            });

            // Callback to notify the parent that the modal has opened.
            // When checking the GUIv, sometimes values were returned before the modal v1 has even opened
            // leading to unexpected behaviors with double modals. This callback notifies the parent that the modal
            // has opened and we can process the MQTT data.
            if (onOpened) {
                onOpened();
            }

            // Connect
            connect();
        }

        // RFB initialization function
        function initRfb() {
            if ($state.rfb != null) {
                $state.rfb.disconnect();
                $state.rfb = null;
            }
            showStatus(locale.getString('remoteconsole.connecting'), 'notification');

            $state.rfb = new RFB({
                target: $state.element.find('#remote-console-canvas').get(0),
                focusContainer: $document[0],
                encrypt: $state.connectionData.encrypt,
                view_only: false,
                shared: true,
                disconnectTimeout: Math.pow(2, 32), // Never trigger a timeout
                onUpdateState: function(rfb, state, oldstate, message) {

                    if((rfb != null && $state.rfb != null) && rfb != $state.rfb) return;

                    switch(state) {
                        case 'normal':
                            // Save the password, since only now we know that it's correct
                            showRemoteConsoleScreen();
                            handleSavePassword($state.connectionData.identifier);
                            break;
                        case 'failed':
                            switch(oldstate) {
                                case 'normal':
                                    showStatus(locale.getString('remoteconsole.failed_normal'), 'alarm');
                                    showReconnectButton();
                                    break;
                                case 'connect':
                                    showStatus(locale.getString('remoteconsole.failed_connect'), 'alarm');
                                    showReconnectButton();
                                    break;
                                case 'SecurityResult':
                                    (rfb.get_onPasswordRequired())(rfb);
                                    break;
                                default:
                                    showStatus(locale.getString('remoteconsole.failed_default'), 'alarm');
                                    showReconnectButton();
                                    break;
                            }
                            break;
                        case 'disconnected':
                            $state.disconnected = true;
                            switch(oldstate) {
                                case 'failed':
                                    // Already handled.
                                    break;
                                case 'normal':
                                    // Normal disconnect
                                    showStatus(locale.getString('remoteconsole.disconnected'), 'notification');
                                    showReconnectButton();
                                    break;
                            }

                            break;
                    }
                },
                onPasswordRequired: function(rfb) {
                    showPasswordScreen();
                    if ($state.firstAttempt) {
                        $state.element.find('#remote-console-password').val('');
                    } else {
                        // Try resending the password with a different salt.
                        if ($state.connectionData.identifierOld && !$state.triedIdentifierOld) {
                            sendPassword($state.connectionData.identifierOld);
                            $state.triedIdentifierOld = true;
                        } else {
                            // Password was entered incorrectly
                            $state.element.find('#remote-console-password').addClass('error').one('input keydown keyup change', function() {
                                $state.element.find('#remote-console-password').removeClass('error');
                            });
                            alert(locale.getString('Incorrect password'));
                        }
                    }
                    $state.element.find('#remote-console-password').focus();
                    $state.firstAttempt = false;
                }
            });
        }

        // Send password function
        function sendPassword(identifierOverride) {
            let identifier = $state.connectionData.identifier;
            if (typeof identifierOverride === 'string') {
                identifier = identifierOverride;
            }
            if($state.disconnected) {
                initRfb();
                $state.rfb.connect(
                    $state.connectionData.host ? $state.connectionData.host : window.location.hostname,
                    $state.connectionData.port,
                    getHashFromPasswordField(identifier),
                    $state.connectionData.path
                );
                $state.triedIdentifierOld = false;
            } else {
                $state.rfb.sendPassword(getHashFromPasswordField(identifier));
            }
        }

        function connect() {
            // Make sure we're sized properly when we connect
            resize();

            // Check if we're already connected
            if(!$state.rfb) {
                // Check if we're already retrieving connection details
                if(!$state.connecting) {
                    $state.connecting = true;

                    // Hide any status messages
                    showStatus(locale.getString('remoteconsole.connecting'), 'notification');
                    // Get connection details
                    ApiService.setOpenedRemoteConsoleVersion(installation.idSite, 1).then(function(response) {
                        if(response.data.success) {
                            // Port 0 means tunnel isn't set up
                            if(response.data.data.port != 0) {
                                // Save connection data for later use
                                $state.connectionData = response.data.data;

                                // This is once again a first attempt
                                $state.firstAttempt = true;

                                // We haven't yet disconnected
                                $state.disconnected = false;

                                // Try setting up the RFB
                                try {
                                    // Set up remote framebuffer
                                    initRfb();

                                    // Connect the remote framebuffer
                                    $state.rfb.connect(
                                        $state.connectionData.host ? $state.connectionData.host : window.location.hostname,
                                        $state.connectionData.port,
                                        $state.connectionData.password !== null ? $state.connectionData.password : '',
                                        $state.connectionData.path
                                    );
                                } catch(error) {
                                    console.error(error);
                                    showStatus(locale.getString('remoteconsole.failed_default'), 'alarm1');
                                    showReconnectButton();
                                }
                            } else {
                                showStatus(locale.getString('remoteconsole.connectiondata_notunnel'), 'alarm2');
                                showReconnectButton();
                            }
                        } else {
                            showStatus(locale.getString('remoteconsole.connectiondata_unauthorized'), 'notification');
                            showReconnectButton();
                        }

                        // We're no longer trying to retrieve connection details
                        $state.connecting = false;
                    }).catch(function(error) {
                        console.error(error);
                        showStatus(locale.getString('remoteconsole.connectiondata_failed'), 'alarm3');
                        showReconnectButton();

                        // We're no longer trying to retrieve connection details
                        $state.connecting = false;
                    });
                }
            }
        }

        function getHashFromPasswordField(identifier) {
            var password = $state.element.find('#remote-console-password');
            if (password.val().length == 0) {
                return '';
            }

            var identifierArray = []
            for (var i = 0; i < 16; i++) {
                identifierArray[i] = (identifier + identifier).charCodeAt(i);
            }
            var salt = "$2a$08$" + bcrypt.encodeBase64(identifierArray, 16);
            var hash = bcrypt.hashSync(password.val(), salt);
            if (hash.length > 8) {
                return hash.substr(hash.length - 8);
            } else {
                alert(locale.getString('remoteconsole.password_hash_error'));
            }
        }

        function disconnect() {
            $state.element.closest('.mfp-wrap').css('background-color', '');

            // Check if we're connected
            if($state.rfb) {
                // Disconnect
                $state.rfb.disconnect();
                $state.rfb = null;
                $state.connectionData = null;
            }

            // Hide any status messages
            hideStatus();
        }

        function sendButton(button) {
            // Check if we're connected
            if($state.rfb) {
                $log.info("Sending button "+button);
                // Mapping buttons to key codes
                // See https://www.cl.cam.ac.uk/~mgk25/ucs/keysymdef.h
                var keymap = {
                    'primary':        65307, // Esc
                    'left-button':    65307, // Esc
                    'secondary':      65293, // Enter
                    'right-button': 65293, // Enter
                    'up':             65362, // Arrow up
                    'left':           65361, // Arrow left
                    'center':         32,    // Space
                    'right':          65363, // Arrow right
                    'down':           65364  // Arrow down
                };

                // Send key
                $state.rfb.sendKey(keymap[button]);
            }
        }

        function handleSavePassword(identifier) {
            if($state.element.find('#remote-console-password-remember').prop('checked')) {
                ApiService.call('/installations/' + installation.idSite + '/remote-console-password', {
                    password: getHashFromPasswordField(identifier)
                }).then(function(response) {
                    // TODO error handling
                }).catch(function() {
                    // TODO error handling
                });
            }
        }

        function showPasswordScreen() {
            $state.element.find('#remote-console-password').removeClass('error');
            $state.element.removeClass('logged-in').addClass('password-needed');
            hideStatus();
        }

        function showRemoteConsoleScreen() {
            $state.element.removeClass('password-needed').addClass('logged-in');
            hideStatus();
        }

        function showStatus(status, type) {
            var statusContainer = $state.element.find('.remote-console-status');
            $state.element.removeClass('password-needed').removeClass('logged-in');
            $state.element.find('.remote-console-status-text').html(status).show();
            statusContainer.removeClass('reconnect');
            statusContainer.removeClass('notification');
            statusContainer.removeClass('alarm');
            statusContainer.addClass(type);
        }

        function showReconnectButton() {
            $state.element.find('.remote-console-status').addClass('reconnect');
            $state.element.find('.remote-console-status-text')
                .append('<br /><br />')
                .append($('<input type="button" class="sg-btn" />')
                    .val(locale.getString('remoteconsole.reconnect'))
                    .click(function() {
                        disconnect();
                        connect();
                    })
                );
        }

        function hideStatus() {
            $state.element.find('.remote-console-status-text').empty().hide();
        }

        function resize() {
            var $display = $state.element.find('.remote-console-display-inner');

            var windowWidth = $($window).width();
            var windowHeight = $($window).height();
            var isPortrait = windowHeight > windowWidth;

            if (windowWidth <= 767) {
                $display.height((windowWidth - 240) * 0.56);
            } else {
                $display.height('');
            }

            if (windowWidth < 686) {
                $display.width(480 - (686 - windowWidth));
            }
            else {
                $display.width('');
            }

            if(windowWidth < 768 && isPortrait && $('#vrm-modal--remote-console').length > 0) {
                $('.remote-console-rotate-message-container').show();
            } else {
                $('.remote-console-rotate-message-container').hide();
            }
        }
    }

})();
